import { useContext, useEffect, useRef, useState } from "react";
import { CSSTransition } from "react-transition-group";
import CloseCross from "../ui/CloseCross";
import ReactDOM from "react-dom";
import { NavLink, useNavigate } from "react-router-dom";
import shyLogo from "../../assets/icons/shy-logo.svg";
import PoweredByContext from "../../store/PoweredByContext";
import portalContext from "../../store/PortalContext";
import { getIcon } from "../../utilities/icon";
import getClassName from "../../utilities/getClassName";

import { portalLogoutIcon, portalNavItems } from "../../data/portalNav";

const PortalNav = ({ showNav, closeNav }) => {
    // Hooks
    const transition = useRef(null);
    const [links, setLinks] = useState(false);
    const poweredByCtx = useContext(PoweredByContext);
    const authCtx = useContext(portalContext);
    const navigate = useNavigate();

    useEffect(() => {
        setLinks(portalNavItems);
    }, []);

    const getLogo = () => {
        let image;

        if (poweredByCtx?.tenant.logoImage) {
            image = poweredByCtx.tenant.logoImage;
        } else {
            console.log(`Logo image not available for ${poweredByCtx.tenantID}`);
        }

        if (image) {
            return image;
        }
    };

    const doPortalLogout = () => {
        //console.log(authCtx)
        authCtx.logout();
        closeNav();
        navigate("/portal/login");
    };

    const renderNavIcon = (icon) => {
        const iconSrc = getIcon(icon)[0];

        if (!iconSrc) {
            return null;
        }

        return (
            <span className="nav__link__icon">
                <img src={iconSrc} alt="" />
            </span>
        );
    };

    return ReactDOM.createPortal(
        <CSSTransition
            nodeRef={transition}
            in={showNav}
            timeout={500}
            unmountOnExit={true}
            classNames={{
                enterDone: "nav-transition",
                enterActive: "nav-transition",
            }}
        >
            <div ref={transition}>
                <div onClick={closeNav} className="nav-overlay" aria-hidden="true" />

                <div className="nav">
                    <div className="nav__inner__close-cross-container">
                        <CloseCross onClick={closeNav} colour={poweredByCtx.isPoweredBy ? "black" : "white"} />
                    </div>

                    <img
                        className="nav__logo"
                        src={poweredByCtx.isPoweredBy ? getLogo() : shyLogo}
                        alt={`${poweredByCtx.isPoweredBy ? poweredByCtx?.tenant?.tenantName : "SHY"} Logo`}
                    />

                    {links && (
                        <div className="nav__links">
                            {links.map((link, i) => {
                                return (
                                    <div className="nav__group" key={i}>
                                        <NavLink
                                            className={({ isActive }) =>
                                                getClassName([
                                                    "nav__link",
                                                    "nav__link--primary",
                                                    isActive && "nav__link--active",
                                                ])
                                            }
                                            to={link.url}
                                            end={link.url === "/portal"}
                                            onClick={closeNav}
                                        >
                                            {renderNavIcon(link.icon)}
                                            {link.name}
                                        </NavLink>
                                        {link.subLinks && (
                                            <>
                                                {link.subLinks.map((link, i) => {
                                                    return (
                                                        <NavLink
                                                            className={({ isActive }) =>
                                                                getClassName([
                                                                    "nav__link",
                                                                    "nav__link--secondary",
                                                                    isActive && "nav__link--active",
                                                                ])
                                                            }
                                                            to={link.url}
                                                            onClick={closeNav}
                                                            key={i}
                                                        >
                                                            {link.name}
                                                        </NavLink>
                                                    );
                                                })}
                                            </>
                                        )}
                                    </div>
                                );
                            })}

                            <div className="nav__group" key="lnk_logout_portal">
                                <button type="button" className="nav__link nav__link--primary" onClick={doPortalLogout}>
                                    {renderNavIcon(portalLogoutIcon)}
                                    Logout
                                </button>
                            </div>
                        </div>
                    )}

                    {/* <Link className={getClassName(getButtonClassName())} to='/' onClick={closeNav}>Request quote</Link> */}
                </div>
            </div>
        </CSSTransition>,
        document.body
    );
};

export default PortalNav;
